import { render, staticRenderFns } from "./workindic.vue?vue&type=template&id=3fa6f1e3&scoped=true&"
import script from "./workindic.vue?vue&type=script&lang=js&"
export * from "./workindic.vue?vue&type=script&lang=js&"
import style0 from "./workindic.vue?vue&type=style&index=0&id=3fa6f1e3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa6f1e3",
  null
  
)

export default component.exports